<div class="load-communication">
    <div class="ibox float-e-margins">
        <div class="ibox-title border-primary no-padding">
            <div class="load-communication-title" (click)="expand()">
                <i class="load-communication-title-icon fa fa-comment-alt"></i>

                <span class="load-communication-title-text" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.communication.title'}]"></span>

                <i class="load-communication-title-expand fa" [ngClass]="{ 'fa-minus': expanded, 'fa-plus': !expanded }"></i>
            </div>
        </div>

        <div class="ibox-content no-padding">

            <div class="load-communication-tab-selector">
                <div class="btn-group chep-tabs">
                    <button class="btn" [ngClass]="{'active' : activeTab === 'notes'}" (click)="activeTab = 'notes'">
                        Notes
                    </button>
                    <button class="btn" [ngClass]="{'active' : activeTab === 'notifications'}" (click)="activeTab = 'notifications'">
                        Notifications
                    </button>
                </div>
            </div>

            <div #notesElement>
                <ng-container *ngIf="expanded && communication && activeTab === 'notes'">
                    <div class="load-note" *ngFor="let note of communication.notes" [ngClass]="{ 'writed-by-me': note.createdBy === currentUserEmail }">
                        <div class="load-note-author">
                            <ng-container [ngSwitch]="note.createdBy">
                                <span *ngSwitchCase="currentUserEmail" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.communication.author.self'}]"></span>
                                <span *ngSwitchDefault>{{ note.createdBy }}</span>
                            </ng-container>
                        </div>
                        <div class="load-note-message" *ngIf="!note.isPicture">
                            {{ note.message }}
                        </div>
                        <div class="load-note-picture" *ngIf="note.isPicture">
                            <i *ngIf="!note.pictureShowed" class="fa fa-image load-note-picture-icon" (click)="showPicture(note)"></i>
                            <img *ngIf="note.pictureShowed" class="load-note-picture-image" [src]="note.pictureUrl">
                            <a *ngIf="note.pictureShowed" class="load-note-download-picture" (click)="downloadPicture(note)">
                                <i class="fa fa-download"></i>
                                <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.communication.download-picture'}]"></span>
                            </a>
                        </div>
                        <div class="load-note-date">
                            {{ note.createdAt | dateDiffFromNow | async }}
                        </div>
                    </div>

                    <div class="no-load-note text-center" *ngIf="communication.notes.length === 0">
                        <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.communication.notes.empty'}]"></span>
                    </div>
                </ng-container>
            </div>

            <div *ngIf="activeTab === 'notifications'" class="m-b-md">
                <ng-container *ngIf="expanded && communication">
                    <div class="load-note" *ngFor="let notification of communication.notifications" [ngClass]="{ 'writed-by-me': notification.createdBy === currentUserEmail }">
                        <div class="load-note-author">
                            <ng-container [ngSwitch]="notification.createdBy">
                                <span *ngSwitchCase="currentUserEmail" [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.communication.author.self'}]"></span>
                                <span *ngSwitchDefault>{{ notification.createdBy }}</span>
                            </ng-container>
                        </div>
                        <div class="load-note-message">
                            {{ notification.message }}
                        </div>
                        <div class="load-note-date">
                            {{ notification.createdAt | dateDiffFromNow | async }}
                        </div>
                    </div>
                </ng-container>

                <div class="no-load-note text-center" *ngIf="communication.notifications.length === 0">
                    <span [i18n]="[{target: 'innerHTML', key: 'local-loads.search.details.communication.notifications.empty'}]"></span>
                </div>
            </div>

        </div>

        <div class="load-communication-footer" *ngIf="expanded && activeTab === 'notes'">
            <form class="load-communication-form" [ngClass]="{ 'active': inputHasFocus }" ngForm (submit)="addNote()">
                <div class="load-communication-form-type" *ngIf="noteTypes">
                    <app-dropdown-button [btnClasses]="'btn-white'" [btnTextKey]="selectedNoteType ? selectedNoteType.defaultLabel : 'zzz'"
                                         [large]="false" [alignLeft]="true" [closeOnClick]="true">
                        <li app-dropdown-button-item *ngFor="let noteType of noteTypes" (click)="selectNoteType(noteType)">
                            <a *ngIf="noteType === selectedNoteType">{{ noteType.defaultLabel }}</a>
                            <span *ngIf="noteType !== selectedNoteType">{{ noteType.defaultLabel }}</span>
                        </li>
                    </app-dropdown-button>
                </div>

                <input type="text" class="load-communication-footer-input" (focus)="onInputFocus()" (blur)="onInputBlur()" name="add-note-message"
                       [(ngModel)]="addNoteMessage" [i18n]="[{target: 'attribute:placeholder', key: 'local-loads.search.details.communication.form.placeholder'}]">

                <div class="load-communication-footer-send" (click)="addNote()">
                    <i class="fa fa-paper-plane"></i>
                </div>
            </form>
        </div>
    </div>
</div>
